import mermaid from "mermaid";

import { StackTemplate } from "../../types";

import {
  DiagramConfig,
  TEMPLATE_DIAGRAMS,
  TOOL_LABELS,
} from "./template-gallery-constants";

// Initialize mermaid once
mermaid.initialize({
  startOnLoad: false,
  theme: "base",
  themeVariables: {
    primaryColor: "#0066ff",
    primaryTextColor: "#fff",
    primaryBorderColor: "#0066ff",
    lineColor: "#0066ff",
    secondaryColor: "#10b981",
    tertiaryColor: "#f3f4f6",
  },
  flowchart: {
    curve: "basis",
    diagramPadding: 15,
    nodeSpacing: 40,
    rankSpacing: 40,
  },
});

/** Returns the human-readable label for a tool value, falling back to the raw value. */
export function toolLabel(val: string): string {
  return TOOL_LABELS[val] ?? val;
}

/** Returns a flat list of tool label strings from any stackConfig shape */
export function stackConfigTools(
  config: StackTemplate["stackConfig"],
): string[] {
  const tools: string[] = [];
  for (const val of Object.values(config)) {
    if (val && typeof val === "string" && val !== "none") {
      tools.push(toolLabel(val));
    }
  }
  return tools;
}

// Get best diagram for a template based on cloud provider
export function getDiagramForTemplate(
  templateSlug: string,
  cloudProvider: string,
): DiagramConfig | null {
  const diagrams =
    TEMPLATE_DIAGRAMS[templateSlug] || TEMPLATE_DIAGRAMS["default"];

  const exactMatch = diagrams.find((d) =>
    d.optimizedFor.includes(cloudProvider),
  );
  if (exactMatch) return exactMatch;

  const k8sDiagram = diagrams.find((d) => d.style === "k8s");
  if (k8sDiagram) return k8sDiagram;

  return diagrams[0] || null;
}
